import { Globe } from 'lucide-react'
import { useTranslation } from '../../core/hooks/useTranslation'
import Button from './Button'

export default function LanguageToggle() {
  const { currentLanguage, toggleLanguage } = useTranslation()

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 hover:bg-[#1E293B]/10"
      title={currentLanguage === 'ar' ? 'Switch to English' : 'التبديل للعربية'}
    >
      <Globe className="w-4 h-4 text-[#1E293B]" />
      <span className="font-medium text-[#1E293B]">
        {currentLanguage === 'ar' ? 'EN' : 'عر'}
      </span>
    </Button>
  )
}